import { isUndefined } from 'core/common/utils/isUndefined';
import { Logger } from '../logger/interfaces';
import { StorageInterface } from './interfaces';

export class SessionStorage implements StorageInterface {
  constructor(private readonly logger: Logger) {}

  get<T>(key: string): T | null {
    if (!key) throw new Error('storage key may not be falsy');

    try {
      const storageValue = sessionStorage.getItem(key);

      if (!storageValue) {
        return null;
      }

      try {
        return JSON.parse(storageValue);
      } catch {
        return storageValue as T;
      }
    } catch (err) {
      this.logger.warn(`Can't load value from persistent store for key: ${key}`);
      throw err;
    }
  }

  set(key: string, newValue: unknown) {
    if (!key) throw new Error('storage key may not be falsy');

    if (isUndefined(newValue)) return;

    try {
      const value = typeof newValue === 'string' ? newValue : JSON.stringify(newValue);

      sessionStorage.setItem(key, value);
    } catch (err) {
      this.logger.warn(`Can't save value to persistent store for key: ${key}`);
      throw err;
    }
  }
}
